<template>
  <div class="supension">
    <!--  -->
    <!-- <img class="img"
         v-if="!show"
         @click="show = !show"
         src="../../static/img/fuli.png" /> -->
    <div v-if="!show"
         class="hideModal">
      <div class="box">
        <div class="box_item font14"
             v-for="(item,index) in list"
             :key="index"
             :style="{'padding': index==0?'':'10px','background': index==0?'':'#fff','borderBottom': index==0?'':'1px dashed #e5e5e5'}"
             @click="toIndex(index)">
          <el-tooltip v-if="item.content"
                      placement="left">
            <div slot="content">
              <div v-if="index== 1">
                <el-image style="width: 120px; height: 120px;text-align: center;"
                          :src="owurl"></el-image>
              </div>
              <div v-if="index== 2">
                <el-image style="width: 120px; height: 120px;text-align: center;"
                          :src="downurl"></el-image>
              </div>
              <div v-if="index==3">
                <div class="font14">电话咨询：</div><br>
                <div class="font18">027-8720-9668 </div>
              </div>
            </div>
            <div>
              <div class="img">
                <img :src="$imgUrl + item.icon"
                     alt="">
              </div>
              <div>{{item.text}}</div>
            </div>
          </el-tooltip>
          <div v-else>
            <el-image v-if="index==0"
                      style="width:106px;right:15px"
                      :src="$imgUrl + 'home/kefu.png'"></el-image>
            <div v-else>
              <div class="img">
                <img :src="$imgUrl + item.icon"
                     alt="">
              </div>
              <div>{{item.text}}</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- 显示联系弹窗 -->
    <div v-if="show"
         class="showModal">
      <i class="closeIcon el-icon-circle-close"
         @click="show = !show"></i>
      <div class="code_top">
        <el-avatar :size="size"
                   :src="url"></el-avatar>
        <div style="font-size:14px;margin-top: 11px;">Hi，我是您的专属增长顾问</div>
        <div style="font-size:12px;margin:9px 0 14px 0">为10000+零售企业提供增长指导</div>
        <el-button style="width:100%;height:32px;"
                   icon="el-icon-headset">在线客服</el-button>
      </div>
      <div class="codeModal">
        <el-image style="width: 170px; height: 170px;text-align: center;margin-left: 40px;"
                  :src="url"></el-image>
        <div style="color:#333333;font-size:14px">进群领取营采鲜销资料包</div>
      </div>
    </div>

    <!-- 意见反馈 -->
    <el-dialog title="意见反馈"
               :visible.sync="opinionShow"
               width="30%"
               append-to-body
               :before-close="handleClose">
      <opinion @close="close"
               ref="opinion"></opinion>
    </el-dialog>
  </div>
</template>
<script>
import opinion from '../views/my/components/opinion.vue'
import { resourceList } from '@/api/api.js'
export default {
  components: { opinion },
  data () {
    return {
      list: [{ text: '在线咨询', content: false }, { text: '微信咨询', content: true, icon: 'home/slider_bar_icon2.png' }, { text: '下载APP', content: true, icon: 'home/slider_bar_icon4.png' }, { text: '电话咨询', content: true, icon: 'home/slider_bar_icon3.png' }, { text: '意见反馈', content: false, icon: 'home/2022041910025140070back.png' }],
      size: 50,
      url: '',
      show: false,
      opinionShow: false,
      data: {
        showIndex: 16,
        pageNumber: 1,
        pageSize: 100
      },
      owurl: '',
      downurl: ''
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  created () {
    // if()
    this.getresourceList(16)
    this.getresourceList(20)
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 100) {
        this.list = [{ text: '在线咨询', content: false }, { text: '微信咨询', content: true, icon: 'home/slider_bar_icon2.png' }, { text: '下载APP', content: true, icon: 'home/slider_bar_icon4.png' }, { text: '电话咨询', content: true, icon: 'home/slider_bar_icon3.png' }, { text: '意见反馈', content: false, icon: 'home/2022041910025140070back.png' }, { text: '返回顶部', icon: 'home/slider_bar_icon6.png' }]
      } else {
        this.list = [{ text: '在线咨询', content: false }, { text: '微信咨询', content: true, icon: 'home/slider_bar_icon2.png' }, { text: '下载APP', content: true, icon: 'home/slider_bar_icon4.png' }, { text: '电话咨询', content: true, icon: 'home/slider_bar_icon3.png' }, { text: '意见反馈', content: false, icon: 'home/2022041910025140070back.png' }]
      }
    },
    async getresourceList (type) {  //获取首页资源
      this.data.showIndex = type;
      const res = await resourceList(this.data)
      // console.log(res)
      if (type == 16) {
        this.downurl = res.data[0].resourceUrl
      } else {
        this.owurl = res.data[0].resourceUrl
      }
      console.log(this.list)
    },
    handleClose () {
      this.close()
      this.$refs.opinion.init()
    },
    close () {
      this.opinionShow = false;
    },
    toIndex (index) {
      switch (Number(index)) {
        case 5:
          window.scrollTo(0, 0);
          break;
        case 4:
          this.opinionShow = true;
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.supension {
  position: fixed;
  right: 10px;
  bottom: 150px;
  // width: 150px;
  // background: rgba(255, 255, 255, 0.8);
  // height: 400px;
  z-index: 22;
  .hideModal {
    margin-right: 20px;
    color: #333;
    width: 90px;
    // height: 420px;
    // background-color: #fff;
    .box {
      width: 100%;
      height: 100%;
      .box_item:hover {
        // background-color: #de1f26;
        // opacity: 0.6;
        // color: #333;
      }
      .box_item {
        cursor: pointer;
        text-align: center;
        // padding: 10px;
        box-sizing: border-box;
        // border-bottom: 1px dashed #e5e5e5;
        // background-color: #fff;
        .img {
          display: flex;
          justify-content: center;
          width: 100%;
          margin-bottom: 10px;
        }
      }
      .box_item:nth-child(6) {
        border-bottom: none;
      }
    }
  }
  .showModal {
    text-align: center;
    width: 250px;
    margin-right: 40px;
    height: 420px;
    background-color: #f6f6f6;
    position: relative;
    .closeIcon {
      position: absolute;
      top: 0;
      right: -34px;
      cursor: pointer;
      color: #f6f6f6;
      font-size: 22px;
    }
    .code_top {
      color: #fff;
      padding: 12px;
      box-sizing: border-box;
      height: 190px;
      background-color: #ff0000;
    }
    .codeModal {
      padding-top: 20px;
      width: 100%;
      text-align: center;
      background-color: #f6f6f6;
    }
  }
  // .img {
  //   width: 80px;
  //   height: 80px;
  //   animation: mymove 2.5s infinite;
  //   -webkit-animation: mymove 2.5s infinite; /*Safari and Chrome*/
  //   animation-direction: alternate; /*轮流反向播放动画。*/
  //   animation-timing-function: ease-in-out; /*动画的速度曲线*/
  // }
  // .img:hover {
  //   cursor: pointer;
  // }
  @keyframes mymove {
    0% {
      transform: scale(1); /*开始为原始大小*/
    }
    25% {
      transform: scale(1.1); /*放大1.1倍*/
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.1);
    }
  }
}
</style>